import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useChatUnreadTotal } from '@/features/Chat';
import { getMyProfile, isProfileStaff } from '@/entities/Profile';
import { routerPath } from '@/shared/config/router';
import { STUDENT_MENUS, TEACHER_MENUS } from '@/shared/config/menu';
import { NestedMenuItem } from '../../components/NestedMenuItem';
import { SimpleMenuItem } from '../../components/SimpleMenuItem';
import styles from './Sidebar.module.scss';

export const Sidebar = () => {
  const { pathname } = useLocation();
  const user = useSelector(getMyProfile);

  const menus = isProfileStaff(user) ? TEACHER_MENUS : STUDENT_MENUS;
  const chatUnreadTotal = useChatUnreadTotal();

  return (
    <div className={styles.container}>
      {menus.length > 0 && (
        <ul className="flex flex-col gap-4" aria-label="Main menu">
          {menus.map((item) => {
            if (item.children && item.children.length > 0) {
              return <NestedMenuItem key={item.id} item={item} pathname={pathname} />;
            }

            return (
              <li key={item.id}>
                <SimpleMenuItem
                  item={item}
                  pathname={pathname}
                  badgeCount={item.href === routerPath.chats ? chatUnreadTotal : undefined}
                />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
